import React, { lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import ServiceWorkerWrapper from "../../components/ServiceWorkerWrapper/ServiceWorkerWrapper";
import LoadingWithBackDrop from "../../_oi/layout/components/loadingwithbackdrop/main";
import MaintenancePage from "../pages/Public/UnderMaintanance/main";
// import { setStorage, getStorage, removeStorage } from "../_metronic/_helpers";
/**
 * 
 * @returns Routes Allows you to access an "isAuthorized" route. If it's false, only "AuthPage" is rendered and able to be accessed.
 *          In order to activate the routes a proper dispatched user needs to be sent to Redux.
 */

const Verify = lazy(() =>
  import('./VerifyBasePageRoutes')
)

const Workspace = lazy(() =>
  import("./WorkspaceBasePageRoutes")
);

// const WorkspaceGBA = lazy(() =>
//   import("./WorkspaceBasePageRoutes")
// );

const PublicPage = lazy(() =>
  import("./PublicBasePageRoutes.jsx")
);

export function Root() {
  // useSelector is part of Redux, it's used to detect if a proper user was formed and sent back from the back end.
  return (
    <React.Fragment>
      <ServiceWorkerWrapper />
      {false ?
        <Routes>
          <Route path="/*" element={
            <React.Suspense fallback={<LoadingWithBackDrop open={true} invisible={true} />}>
              <MaintenancePage />
            </React.Suspense>
          }
          />
        </Routes>
        :
        <Routes>
          <Route path="/verify/*" element={
            <React.Suspense fallback={<LoadingWithBackDrop open={true} invisible={true} />}>
              <Verify />
            </React.Suspense>
          }
          />
          <Route path="/workspace/*" element={
            <React.Suspense fallback={<LoadingWithBackDrop open={true} invisible={true} />}>
              <Workspace />
            </React.Suspense>

          }
          />
          {/* <Route path="/workspace/gba/*"   element={
        <React.Suspense fallback={<LoadingWithBackDrop open={true} invisible={true}/>}>
          <Workspace/> 
        </React.Suspense>
        
      } 
      /> */}
          {/* <Route path="/take/assessments" element={
        <React.Suspense fallback={<LoadingWithBackDrop open={true} invisible={true}/>}>
          <AssesmentComponent />
        </React.Suspense>
      }
      /> */}
          <Route path="/*" element={
            <React.Suspense fallback={<LoadingWithBackDrop open={true} invisible={true} />}>
              <PublicPage />
            </React.Suspense>
          }
          />
        </Routes>
      }

    </React.Fragment>
  );
}
